import { Briefcase, Building, Calendar, MapPin } from "lucide-react";
import Button from "../../../components/common/Button";

const JobCard = ({ job, navigate, index }) => (
    <div className="group p-6 hover:bg-gray-50 transition-all duration-300 relative">
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary-600 transform scale-y-0 group-hover:scale-y-100 transition-transform duration-300"></div>
        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-4">
            <div className="flex-1">
                <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <Briefcase className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                        <h4 className="font-bold text-lg text-secondary-800 group-hover:text-primary-700 transition-colors duration-300">
                            {job.title}
                        </h4>
                        <div className="flex items-center gap-4 mt-2 text-sm text-secondary-600">
                            <div className="flex items-center">
                                <Building className="w-4 h-4 mr-1" />
                                {job.recruiter_name}
                            </div>
                            <div className="flex items-center">
                                <MapPin className="w-4 h-4 mr-1" />
                                {job.location}
                            </div>
                            {job.job_type && (
                                <div className="flex items-center">
                                    <Calendar className="w-4 h-4 mr-1" />
                                    {job.job_type}
                                </div>
                            )}
                        </div>
                        {job.salary_min && job.salary_max && (
                            <div className="mt-2">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                    ${job.salary_min} - ${job.salary_max}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-3">
                <div className="text-right text-sm text-secondary-500">
                    <div>Posted {new Date(job.created_at).toLocaleDateString()}</div>
                    {job.applicants_count && (
                        <div className="font-medium">{job.applicants_count} applicants</div>
                    )}
                </div>
                <Button 
                    size="sm" 
                    onClick={() => navigate(`/job-details/${job.id}`)}
                    className="bg-primary-600 hover:bg-primary-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
                >
                    Apply Now
                </Button>
            </div>
        </div>
    </div>
);

export default JobCard;